import { render, staticRenderFns } from "./QueryMyPropertySchemePlanApplications.vue?vue&type=template&id=702ca2eb"
import script from "./QueryMyPropertySchemePlanApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryMyPropertySchemePlanApplications.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports